import React, { useEffect, useState, useRef, useMemo  } from "react";
import { FaSearch, FaRegTimesCircle, FaDownload, FaRegEye, FaVoteYea, FaRegFilePdf, FaRegFileExcel } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { HiRefresh } from "react-icons/hi";
import "../../css/makeTable.css";
import { getData } from "../../store/utils";
import Loader from "../../component/Loader";
import OrderListTable from "./OrderListTable";
import Modal from "react-modal";
import Swal from "sweetalert2";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useAsyncDebounce,
  usePagination,
  useSortBy,
} from "react-table"; 
import { formatDateTimeString, formatNumberWithCommasAndDecimals } from "../../component/common";

function OrdersList() {
  const userRole = localStorage.getItem("USER_ROLE");
  const [merchantUserData, setMerchantUserData] = useState([]);
  const [searchBoxValue, setSearchBoxValue] = useState("");
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("desc");
  const [errorMessage, setErrorMessage] = useState("");
  const [orderQuotationOpen, setOrderQuotationOpen] = React.useState(false);
  const [orderQuotationData, setOrderQuotationData] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [saveOrderFlag, setSaveOrderFlag] = React.useState(false);
  const [saveOrderFlagItem, setSaveOrderFlagItem] = React.useState(null);
  const history = useHistory();
  const [checkedItems, setCheckedItems] = useState({
    loanApplicationForm: false,
    agreement: false,
    kfs: false,
    osv: false,
    cam: false,
  });

  
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "none",
      padding: "0px",
    },
  };

  const handleInputChange = (e) => {
    setSearchBoxValue(e.target.value);
  };

  const resetFilters = () => {
    setSearchBoxValue("");
    setPageIndex(0);
    setSortBy("");
    setOrderBy("desc");
  };

  const closeModal = () => {
    setIsOpen(false);
    setOrderQuotationOpen(false);
    setCheckedItems({
      loanApplicationForm: false,
      agreement: false,
      kfs: false,
      osv: false,
      cam: false,
    });
  };
  
  const fetchData = async (page = 0, pageSize = 10, sortBy = "", orderBy = "") => {
    setIsLoadingOn(true);
    const pageNumber = page + 1;
    let apiUrl = `distributorOrder/getOrders?page=${pageNumber}&pageSize=${pageSize}`;

    if (searchBoxValue) {
      apiUrl += `&search=${searchBoxValue}`;
    }

    if (sortBy && orderBy) {
      apiUrl += `&sortBy=${sortBy}&orderBy=${orderBy}`;
    }

    try {
      const tempData = await getData(apiUrl);
      if (tempData.statusCode === 200) {
        const records = tempData?.data?.records || [];
        setMerchantUserData(records);
        setPageCount(tempData.data.pagination.totalPagesCount);
        setTotalRecords(tempData.data.pagination.totalRecords);
  
        if (records.length === 0) {
          setErrorMessage("");
        }
      } else {
        setErrorMessage("No Data Found");
        setMerchantUserData([]);
      }
    } catch (error) {
      setErrorMessage("");
      setMerchantUserData([]);
    } finally {
      setIsLoadingOn(false);
    }
  };

  const handleSort = (column) => {
    let newOrderBy = "asc";
    if (sortBy === column.id) {
      newOrderBy = orderBy === "asc" ? "desc" : "asc";
    }
    setSortBy(column.id);
    setOrderBy(newOrderBy);
  };

  useEffect(() => {
    fetchData(pageIndex, pageSize, sortBy, orderBy);
  }, [pageIndex, pageSize, sortBy, orderBy]);

  const openModalQuationData = async (orderId) => {
    setOrderQuotationOpen(true);
    setIsLoadingOn(true);
    let tempData = await getData(`distributorOrder/getOrderDetailByOrderId?orderId=${orderId}`);
    setIsLoadingOn(false);
    if (tempData.statusCode == 200) {
      setOrderQuotationData(tempData.data);
    } else {
      Swal.fire({
        title: "Error!",
        text: tempData?.data?.errors.msg || "Something went wrong!!!",
      });
    }
  };

  const handleGetOrderAgreement = async (orderId) => {
    setIsLoadingOn(true);
    const response = await getData(
      `distributorOrder/getOrderAgreementFile?orderId=${orderId}`
    );
    setIsLoadingOn(false);
    if (response.statusCode === 200) {
      if (response?.data?.[0]?.orderAgreement) {
        const downloadLink = document.createElement("a");
        downloadLink.href = response.data[0].orderAgreement;
        downloadLink.target = "_blank";
        downloadLink.rel = "noopener noreferrer";
        downloadLink.click();
      } else {
        // alert("Order agreement not found.");
        Swal.fire({
          title: "Error!",
          message: "Order agreement not found!",
        });
      }
    } else {
      Swal.fire({
        title: "Error!",
        message: response?.data?.errors.msg || "Something went wrong!!!",
      });
    }
  };

  const handleGetOrdersCreditNote = async (orderId) => {
    setIsLoadingOn(true);
    try {
      const response = await getData(
        `distributorOrder/getOrdersCreditNote?orderId=${orderId}`
      );
      setIsLoadingOn(false);
      if (response.statusCode === 200) {
        if (!response?.data || (Array.isArray(response?.data) && response?.data?.length === 0)) {
          Swal.fire({
            icon: "warning",
            title: "No Data Found",
            text: "No Credit Note record found for this order.",
          });
          return;
        }

        if (response?.data?.Location) {
          const downloadLink = document.createElement("a");
          downloadLink.href = response.data.Location;
          downloadLink.target = "_blank";
          downloadLink.rel = "noopener noreferrer";
          downloadLink.click();
        } else {
          Swal.fire({
            title: "Error!",
            message: "Order Credit not found!",
          });
        }
      } else {
        Swal.fire({
          title: "Error!",
          message: response?.data?.errors.msg || "Something went wrong!!!",
          });
        }
    } catch (error) {
      setIsLoadingOn(false);
      Swal.fire({
        title: "Error!",
        message: "Something went wrong! Please try again later.",
      });
    }
  };

  const handleGetCamReportData = async (orderId) => {
    setIsLoadingOn(true);
    const response = await getData(`distributorOrder/getCamFile?orderId=${orderId}`);
    setIsLoadingOn(false);
    if (response.statusCode === 200) {
      if (response?.data[0]?.camFile) {
        const downloadLink = document.createElement("a");
        downloadLink.href = response?.data[0]?.camFile;
        downloadLink.target = "_blank";
        downloadLink.rel = "noopener noreferrer";
        downloadLink.click();
      } else {
        Swal.fire({
          icon: "error",
          text: "No data found!",
        });
      }
    } else {
      Swal.fire({
        icon: "Error",
        title: "Error!",
        text: "Something went wrong!!!",
      });
    }
  };

  const orderQuotationColumns = useMemo(() => [
    {
      Header: "Sr. No.",
      accessor: (row, i) => i + 1,
      Cell: ({ cell }) => (
        <span style={{ fontWeight: "600", fontSize: "0.875rem" }}>
          {cell.row.index + 1}.
        </span>
      ),
    },
    {
      Header: "Order Id",
      accessor: "orderId",
    },
    {
      Header: "Brand",
      accessor: "brand",
      Footer: <div className="tblFooterColor">Total Amount</div>,
    },
    {
      Header: "Item",
      accessor: "item",
    },
    {
      Header: "Color",
      accessor: "color",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Rate",
      accessor: "rate",
      Cell: ({ cell }) => {
        const rate = cell.row.original.rate;
        return (
          <>
            <span>{rate && rate.toFixed(2)}</span>
          </>
        );
      },
    },

    {
      Header: "Gst Applicable",
      accessor: "isGstApplicable",
      Cell: ({ cell }) => {
        const GstApplicable = cell.row.original.isGstApplicable;
        return (
          <>
            <span>{GstApplicable == 1 ? "Yes" : "No"}</span>
          </>
        );
      },
    },
    {
      Header: "Total Amount",
      accessor: "amountWithGST",

      Cell: ({ value }) => {
        const numericValue = Number(value);
        if (!isNaN(numericValue)) {
          return formatNumberWithCommasAndDecimals(numericValue);
        } else {
          return value || "-";
        }
      },
      Footer: (info) => {
        const totalAmount = info.rows.reduce(
          (sum, row) => sum + row.values.amountWithGST,
          0
        );

        return (
          <div className="tblFooterColor">
            {totalAmount && formatNumberWithCommasAndDecimals(totalAmount)}
          </div>
        );
      },
    },
    {
      Header: "Created Date",
      accessor: "OrderDetailDateTime",
      Cell: ({ cell }) => {
        return (
          <>
            <span>
              {cell.row.original.OrderDetailDateTime &&
                formatDateTimeString(cell.row.original.OrderDetailDateTime)}
            </span>
          </>
        );
      },
    },
  ]);

  const columns = useMemo(
    () => [
      { Header: "Order Code", 
        accessor: "orderCode",
        Cell: ({ cell }) => {
            return (
              <>
                <div className="loanIdDownloadBtnDiv">
                  <button
                    className="btn btn-sm someprobtn view-log-detail loanTblDownloadLoanIdBtn"
                    title="View details"
                    value={cell.row.original.orderCode}
                    onClick={() => {
                    //   if (userRole === "Admin" || userRole === "Operation") {
                        displayMerchantInfo(cell.row.original);
                    //   }
                    }}
                  >
                    <span style={{ fontWeight: "600" }}>
                      {cell.row.original.orderCode}
                    </span>
                  </button>
                </div>
              </>
            );
          },
          filter: "fuzzyText",
          disableSortBy: true,
          disableFilters: false,
      },
      { Header: "Merchant Id", accessor: "userId" },
      { Header: "Shop Name", accessor: "shopName" },
      {
        Header: "Date",
        accessor: "createdDate",
        Cell: ({ cell }) => formatDateTimeString(cell.row.original.createdDate),
      },
      { Header: "Time", accessor: "createdTime" },
      {
        Header: "Download",
        accessor: "",
        Cell: ({ cell }) => {
          return (
            <>
              <div className="text-center">
                <button
                  type="button"
                  onClick={() =>
                    handleGetOrderAgreement(cell.row.original.orderId)
                  }
                  style={{
                    fontSize: 22,
                    color: "#6E12F9",
                    border: "none",
                    background: "none",
                  }}
                  title={`Download order agreement for ${cell.row.original.orderCode}`}
                >
                  <FaRegFilePdf />
                </button>

                <button
                  type="button"
                  onClick={() =>
                    handleGetOrdersCreditNote(cell.row.original.orderId)
                  }
                  style={{
                    fontSize: 22,
                    color: "#6E12F9",
                    border: "none",
                    background: "none",
                  }}
                  title={`Download order's credit note for ${cell.row.original.orderCode}`}
                >
                  <FaRegFileExcel />
                </button>

                <button
                  type="button"
                  onClick={() =>
                    handleGetCamReportData(cell.row.original.orderId)
                  }
                  style={{
                    fontSize: 22,
                    color: "#6E12F9",
                    border: "none",
                    background: "none",
                  }}
                  title={`Download Cam Report for ${cell.row.original.orderCode}`}
                >
                  <FaRegFileExcel />
                </button>
              </div>
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "statusName",
        Cell: ({ cell }) => {
          const status = cell.row.original.statusName;
          return (
            <div className="loanIdDownloadBtnDiv text-center">
              <button
                className={`badge badge-pill ${
                  status === "Order Disbursed" || status === "Approved"
                    ? "badge-success"
                    : status.includes("Pending")
                    ? "badge-warning"
                    : status.includes("Reject")
                    ? "badge-danger"
                    : status.includes("Delete")
                    ? "badge-secondary"
                    : "badge-primary"
                }`}
              >
                <span style={{ fontWeight: "600" }}>{status}</span>
              </button>
            </div>
          );
        },
      },
      { Header: "App Source", accessor: "source" },
      { Header: "Mode", accessor: "paymentType" },
      {
        Header: "Action",
        accessor: "csvPath",
        Cell: ({ cell }) => {
          console.log("cell.row.original+++", cell.row.original.status);
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="loanIdDownloadBtnDiv text-center">
                <a
                  style={{
                    fontSize: 22,
                    color: "#6E12F9",
                    cursor: "pointer",
                    marginRight: 20,
                  }}
                  href={cell.row.original.csvPath}
                >
                  {cell.row.original.csvPath == null ? "" : <FaDownload />}
                </a>
                <button
                  onClick={() =>
                    openModalQuationData(cell.row.original.orderId)
                  }
                  style={{
                    fontSize: 22,
                    color: "#6E12F9",
                    border: "none",
                    background: "none",
                  }}
                >
                  <FaRegEye />
                </button>
              </div>
              {cell?.row?.original?.status == 30 && (
                <div className="loanIdDownloadBtnDiv text-center">
                  <button
                    title="Order Flag"
                    onClick={() => {
                      setSaveOrderFlagItem(cell.row.original);
                      setSaveOrderFlag(true);
                    }}
                    style={{
                      fontSize: 22,
                      color: "#007bff",
                      border: "none",
                      background: "none",
                    }}
                  >
                    <FaVoteYea />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const displayMerchantInfo = (user) => {
    const newTab = window.open(
      `/OrderDetails?userId=${user.userId}&orderId=${user.orderId}&orderType=ORDER`,
      "_blank"
    );
  
    if (!newTab) {
      history.push({
        pathname: "/OrderDetails",
        state: { userId: user.userId, orderId: user.orderId },
      });
    }
  };

  return (
    <div>
      {isLoadingOn && <Loader />}
      <h4 style={{ marginBottom: 10 }}>Orders List</h4>
      <div className="customHeaderTable">
        <div className="container-fluid">
          <div className="row alignmentTable">
            <div className="col-md-2">
              <input
                type="text"
                className="searchInputField"
                onChange={handleInputChange}
                placeholder="Enter Search Text"
                value={searchBoxValue}
              />
            </div>
            <div className="col-md-2 text-center">
              <button className="searchTableData" onClick={() => fetchData(pageIndex, pageSize, sortBy, orderBy)}>
                <FaSearch /> Search
              </button>
            </div>
            <div className="col-md-2 text-center" onClick={resetFilters}>
              <button className="resetTableData">
                <HiRefresh /> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="orderListDataFooter">
        <OrderListTable
          data={merchantUserData}
          userRole={userRole}
          columns={columns}
          pageCount={pageCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          totalRecords={totalRecords}
          handleSort={handleSort}
          sortBy={sortBy}
          orderBy={orderBy}
          handleGotoPage={setPageIndex}
          errorMessage={errorMessage}
        />
      </div>
      <Modal
        isOpen={orderQuotationOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {isLoadingOn ? <Loader /> : null}
        <button className="modalCloseBtn" onClick={closeModal}>
          <FaRegTimesCircle />
        </button>
        <h4 className="pleaseSelectStatus">Order Quotation List</h4>
        <div className="modalUserStatusQuatation">
          {orderQuotationData && (
            <Table columns={orderQuotationColumns} data={orderQuotationData} />
          )}
        </div>
      </Modal>
    </div>
  );
}

export default OrdersList;



function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <span>
      Search:{" "}
      <input
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} records...`}
        className="searchFilter"
      />
    </span>
  );
}

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {
  const count = preFilteredRows.length;

  return (
    <div>
      <input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value.toString().toLowerCase() || undefined); // Set undefined to remove the filter entirely
        }}
        // placeholder={`Search ${count} records...`}
        className="searchFilter"
      />
      <i className="flaticon-search searchIcon"></i>
    </div>
  );
}

// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  // Render a multi-select box
  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="">All</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}

// This is a custom filter UI that uses a
// slider to set the filter value between a column's
// min and max values
function SliderColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  // Calculate the min and max
  // using the preFilteredRows

  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    preFilteredRows.forEach((row) => {
      min = Math.min(row.values[id], min);
      max = Math.max(row.values[id], max);
    });
    return [min, max];
  }, [id, preFilteredRows]);

  return (
    <>
      <input
        type="range"
        min={min}
        max={max}
        value={filterValue || min}
        onChange={(e) => {
          setFilter(parseInt(e.target.value, 10));
        }}
      />
      <button onClick={() => setFilter(undefined)}>Off</button>
    </>
  );
}

// This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to
// ones that have values between the two
function NumberRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id },
}) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0;
    preFilteredRows.forEach((row) => {
      min = Math.min(row.values[id], min);
      max = Math.max(row.values[id], max);
    });
    return [min, max];
  }, [id, preFilteredRows]);

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <input
        value={filterValue[0] || ""}
        type="number"
        onChange={(e) => {
          const val = e.target.value;
          setFilter((old = []) => [
            val ? parseInt(val, 10) : undefined,
            old[1],
          ]);
        }}
        placeholder={`Min (${min})`}
        style={{
          width: "70px",
          marginRight: "0.5rem",
        }}
      />
      to
      <input
        value={filterValue[1] || ""}
        type="number"
        onChange={(e) => {
          const val = e.target.value;
          setFilter((old = []) => [
            old[0],
            val ? parseInt(val, 10) : undefined,
          ]);
        }}
        placeholder={`Max (${max})`}
        style={{
          width: "70px",
          marginLeft: "0.5rem",
        }}
      />
    </div>
  );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  // return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Our table compone

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}

function Table({ columns, data }) {
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    //state,
    visibleColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy, //sort data
    usePagination //use pagination
  );

  // We don't want to render all of the rows for this example, so cap
  // it for this use case
  //const firstPageRows = rows.slice(0, 10);

  return (
    <>
      <div>
        <table {...getTableProps()} className="dashboardTable">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="tableHeader"
              >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    {/* Add a sort direction indicator */}
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? "↓" : "↑") : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
            {/* <tr>
                    <th
                      colSpan={visibleColumns.length}
                      style={{
                        textAlign: 'left',
                      }}
                    >
                    </th>
                  </tr> */}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="tableTd">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
          <tfoot className="orderTableFooter">
            {footerGroups.map((group) => (
              <tr {...group.getFooterGroupProps()}>
                {group.headers.map((column) => (
                  <td {...column.getFooterProps()}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        </table>
        <div className="row m-0">
          <div className="pagination col-lg-12">
            <div className="col-lg-2">
              <button
                className="defaultPaginationButton"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>{" "}
              <button
                className="defaultPaginationButton"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>{" "}
              <button
                className="defaultPaginationButton"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <button
                className="defaultPaginationButton"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>{" "}
            </div>
            <div className="col-lg-2">
              <span>
                Total Records <strong>{rows.length}</strong>{" "}
              </span>
            </div>
            <div className="col-lg-2">
              <span>
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>{" "}
              </span>
            </div>
            <div className="col-lg-3">
              <span>
                Go to page{" "}
                <input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                  }}
                  className="gotoPage"
                />
              </span>{" "}
            </div>
            <div className="col-lg-3">
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
                className="selectDisplayNoOfRecords"
              >
                {[10, 20, 30, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <br />
      </div>
    </>
  );
}
filterGreaterThan.autoRemove = (val) => typeof val !== "number";


